import React from "react";
import DownloadButtons from "../download-buttons/downloadButtons";
import { Link } from 'react-scroll';

class Download extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section id="downloads" className="bg-image">
          <div className="row m-0">
            <div className="col-1 col-lg-3 col-sm-2" style={{
              backgroundImage: "url(img/download-background-left-resized.png)",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right",
            }}>
            </div>
            <div className="col-10 col-lg-6 col-sm-8 ptb-100">
              <div className="section-heading text-center mb-1 text-white">
                <h2 className="text-white">Download The App</h2>
                <p style={{ fontWeight: 400, fontSize: "25px" }}>Please note your MRX/AVM* must be running MCU version 68 and Network Module Version 1.109.164 or later.</p>
                <p style={{ fontWeight: 400, fontSize: "14px", fontStyle: "italic" }}>(*MRX 540, MRX 740, MRX 1140, AVM 70 and AVM 90 models only)</p>
                {/* <Link to="instructions" smooth={true} duration={500} className="page-scroll" style={{ fontSize: "16px" }}>
                  <i>Learn how to enable Auto and Beta Updates</i>
                </Link> */}
                <div className="action-btns mt-4">
                  <DownloadButtons center={true} />
                </div>
              </div>
            </div>
            <div className="col-1 col-lg-3 col-sm-2" style={{
              backgroundImage: "url(img/download-background-right-resized.png)",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "left",
            }}>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default Download;
